<main>
  <loading-overlay [isLoading]="isLoading" />
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Inventory_Types_Title' | translateWF: 'Inventory Types' }}</h1>
        <div class="page__title_buttons">
          <p-button *ngIf="canEdit()" [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (onClick)="openInventoryTypeModal()" />
        </div>
      </div>
    </div>

    <p-card data-variant="compact">
      <p-table
        dataKey="id"
        [value]="allInventoryTypes"
        [paginator]="true"
        [rows]="25"
        [rowsPerPageOptions]="[15, 25, 50]"
        selectionMode="single"
        [customSort]="true"
        (sortFunction)="localizedSort($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">{{ 'Inventory_Types_Name' | translateWF: 'Name' }} <p-sortIcon field="name" /></th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr class="cursor-pointer">
            <td>
              {{ localHelperTranslate.getLocalizedValue(item.name) }}
            </td>

            <td class="!text-end">
              <p-button icon="pi pi-pencil" variant="text" (onClick)="openInventoryTypeModal(item)" />
              <p-button *ngIf="canEdit()" icon="pi pi-trash" variant="text" (onClick)="deletePopup($event, item)" />
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</main>
<p-confirmdialog key="deleteConfirm" styleClass="modal_small" />
